<!-- The buttons that are used to navigate to another page -->
<template>
    <button
        data-button
        :data-styling-type="styling"
        :data-direction="direction"
        v-on:click.prevent="navButtonClicked"
        :id="`button-${id}`"
        ref="button"
        :disabled="secondsLeft > 0 && countdownType !== `Off`"
        :data-nav-mobile="(state.global.isMobile === true && state.layout.ProgressBar.ShowPercentageBottom === true) || (state.global.isMobile === true) ? `` : false"
    >
        <span>
            {{ buttonText }}
            <span data-enter-action v-if="shouldShowEnterText">
                Enter
                <font-awesome-icon icon="arrow-turn-up" />
            </span>
        </span>
    </button>
</template>

<script>
import Vue from "vue";
export default {
    name: `nav-button`,
    data() {
        return {
            secondsLeft: 0,
        };
    },
    props: {
        showEnterText: {
            type: Boolean,
            default: true,
        },
        direction: {
            type: String,
            default: ``,
        },
        styling: {
            type: String,
        },
        text: {
            type: String,
        },
        isNavigation: {
            type: Boolean,
            default: true,
        },
        id: {
            type: String,
            default: ``,
        },
        // Buttons can have a countdown period in which the button is disabled for an amount of seconds
        countdownInSeconds: {
            type: Number,
            default: -1,
        },
        countdownType: {
            type: String,
            default: `Off`,
        },
    },
    watch: {
        countdownInSeconds: function () {
            this.setCountdownInterval();
        },
    },
    computed: {
        shouldShowEnterText: function() {
            return  this.direction === `right` 
                && this.showEnterText === true
                && this.state.layout.HideRequiredFieldsText === false 
                && (this.secondsLeft === 0 || this.secondsLeft === -1) 
                && this.state.global.isMobile === false;
        },
        state: function () {
            return this.$store.state;
        },
        buttonText: function () {
            let buttonText = this.text;

            if (this.secondsLeft > 0 && this.countdownType === `Button`) buttonText = this.state?.text?.rs_wait_number_of_seconds?.replace(`{0}`, `${this.secondsLeft}`);

            return buttonText;
        },
    },
    methods: {
        navButtonClicked: function (e) {
            this.$emit(`element-click`, e);

            if(this.secondsLeft > 0) return;
            // A layoutId means the user wants to test the styling of a layout, but the buttons can't be used otherwise
            if (this.state.global.isPreview || this.isNavigation === false) return;

            if (this.direction === `right`) {
                this.$store.dispatch(`nextButtonClicked`);
            } else if (this.direction === `left`) {
                clearInterval(this.state.global.countdownInterval);
                this.$store.dispatch(`loadPageData`, {
                    actionType: `Previous`,
                });
            }
        },
        setCountdownInterval: function () {
            this.secondsLeft = this.countdownInSeconds;
            let _this = this;

            if (this.secondsLeft > -1 && this.countdownType !== `Off`) {
                this.state.global.countdownInterval = setInterval(() => {
                    _this.secondsLeft--;

                    if (_this.secondsLeft <= 0) {
                        clearInterval(_this.state.global.countdownInterval);

                        if (this.state.page.countdownGoSettings.automaticNextQuestion) {
                            Vue.nextTick(function () {
                                _this.$refs.button.click();
                            });
                        }
                    }
                }, 1000);
            }
        },
    },
    mounted() {
        this.setCountdownInterval();
    },
};
</script>

<style scoped>
[data-button] {
    flex: 1 1 340px;
    min-width: 0;
    max-width: 340px;
    width: 100%;
    padding: 15px;

    svg {
        position: relative;
        left: 0;
        top: 2px;
        transition: 0.2s ease-out;
    }

    &[data-direction="left"] {
        flex-direction: row-reverse;

        svg {
            margin-right: 10px;
        }

        &:hover {
            svg {
                left: -2px;
            }
        }
    }

    &[data-direction="right"] {
        [data-icon="arrow-turn-up"] {
            transform: scaleX(-1) rotate(90deg)
        }
        svg {
            left: -3px;
            margin-left: 10px;
        }

        &:hover {
            svg {
                left: 0px;
            }
        }

        [data-enter-action] {
            border-radius: 24px;
            background: #FFFFFF1A;
            font-size: 12px;
            font-weight: normal;
            padding: 5px 8px;
        }
    }
    &[data-nav-mobile] {
        min-width: 100px;
        width: 100%;
        &[data-direction="right"] {
            margin: 10px 0 10px 10px;
            svg {
                margin-left: 0px;
            }
        }
        &[data-direction="left"] {
            margin: 10px 10px 10px 0;
            svg {
                margin-right: 0px;
            }
        }
    }
}
</style>